module.exports = __webpack_public_path__ + "img/6-2.53cec156.webp";